import { BaseService } from "../base.service";
import { environment as config } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class TokenIssueService extends BaseService {
    prefixUrl = 'token-issue';

    constructor(
        public override http: HttpClient
    ) {
        super(http);
        this.apiURL = config.gogarage_api;
    }


    generateGoCarHelperToken() {
        return this.get(`${this.prefixUrl}/gocar-helper-token`);
    }
}
